import Options from "../types/options";

const defaultOptions: Options = {
  openDelimiter: "{%",
  closeDelimiter: "%}",
  minimified: true,
};

export default defaultOptions;
